import React from "react";
export default function FinancialDetails() {
  return (
    <div className="section borderLight">
      <h2>FinancialDetails</h2>
      <p>Coming soon</p>
    </div>
  );
}
